var app = angular.module("leonardo");

var EditStepsDialog = function ($scope, $filter, ngDialog,
  PermissionService, ApprovalStepService, AccountUserService) {

  $scope.approvalStepService = ApprovalStepService;
  $scope.permissionService = PermissionService;
  $scope.task = $scope.ngDialogData.task;
  $scope.data = {}
  if ($scope.task  && !isEmpty($scope.task.approval_sequences)) {
    angular.forEach($scope.task.approval_sequences, function (sequence) {
      if (sequence.id === $scope.task.current_sequence) {
        $scope.data.approval_steps = $filter('orderBy')(angular.copy(sequence.approval_steps), 'index');
      }
    });
  }

  $scope.showEditApprovalDialog = function (index) {
    ApprovalStepService.get($scope.data.approval_steps[index].id).then(function (step) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/template/approval.html',
        controller: 'ApprovalDialog',
        className: 'ngdialog-theme-default ngdialog-approvals',
        data: {
          template: $scope.data,
          data: step,
          action: 'edit',
          isEditStepInProgress: true,
          propertyId: $scope.task.property
        }
      }).then(function (result) {
        $scope.data.approval_steps[index] = result;
      });
    });

  };

  $scope.getApprovalName = function (user) {
    return $filter('username')(user) + ' - ' + user.email;
  }

  $scope.canEditSteps = function (step) {
    if (PermissionService.isOwner()) return true;
    var current_user = AccountUserService.currentAccountUser.user;
    let approversIds = [];
    let current_step = step || $scope.current_step;
    var approver = false;
    if (current_step && angular.isArray(current_step.user_approvers)) {
      current_step.user_approvers.map(user => {
        if (!approversIds.includes(user.id)) {
          approversIds.push(user.id);
        }
      });
    }
    if (approversIds.length > 0) {
      angular.forEach(approversIds, function (step_approver) {
        if (current_user.id === step_approver) {
          approver = true;
        }
      })
    }
    return approver;
  }
};

app.controller('EditStepsDialog', ['$scope', '$filter', 'ngDialog',
  'PermissionService', 'ApprovalStepService', 'AccountUserService', EditStepsDialog]);
